import React, { useEffect, useState } from "react";
import "./admin_students.css";

import exportIcon from "../../Assets/export button.png";

import Sidebar from "../../Components/3rd page(Dashboard)/sidebar";

import AOS from "aos";
import "aos/dist/aos.css";

import {
  FiSearch,
  FiEdit2,
  FiTrash2,
  FiSlash,
} from "react-icons/fi";

export default function AdminUsers() {

  /* =========================
     STATES
  ========================= */

  const [collapsed, setCollapsed] =
    useState(false);

  /* =========================
     AOS
  ========================= */

  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-quart",
      once: true,
      mirror: false,
      offset: 0,
    });
  }, []);

  /* =========================
     USERS
  ========================= */

  const users = [
    {
      id: 1,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "General",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 2,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Student",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 3,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Admin",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 4,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "General",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 5,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Student",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 6,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Student",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 7,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Student",
      status: "Active",
      enrolled: "May 12,2019",
    },

    {
      id: 8,
      name: "Arlene McCoy",
      username: "@arlenem",
      role: "Admin",
      status: "Active",
      enrolled: "May 12,2019",
    },
  ];

  return (

    <div className="admin_users_layout">

      {/* =========================
         SIDEBAR
      ========================= */}

      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      {/* =========================
         MAIN
      ========================= */}

      <div
        className={`admin_users_main ${
          collapsed
            ? "collapsed_main"
            : ""
        }`}
      >

        {/* =========================
           TOPBAR
        ========================= */}

        <div
          className="admin_users_topbar"
          data-aos="fade-down"
        >

          {/* LEFT */}

          <div
            className="admin_users_topbar_left"
            data-aos="fade-right"
            data-aos-delay="100"
          >

            <div className="admin_users_heading">

              <h1>All Users</h1>

              <p>
                Find all Admin and Students here
              </p>

            </div>

          </div>

          {/* RIGHT */}

          <div
            className="admin_users_topbar_right"
            data-aos="fade-left"
            data-aos-delay="150"
          >

            {/* NOTIFICATION */}

            <div className="admin_notification">

              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>

                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>

              <span className="notification_dot"></span>

            </div>

            {/* EXPORT */}

            <button className="admin_users_export_btn">

              Export CSV

              <img
                src={exportIcon}
                alt=""
              />

            </button>

          </div>

        </div>

        {/* =========================
           CONTENT
        ========================= */}

        <div className="admin_users_content">

          {/* TITLE */}

          <div
            className="admin_users_title"
            data-aos="fade-up"
            data-aos-delay="200"
          >

            All Users (12,345)

          </div>

          {/* =========================
             FILTER ROW
          ========================= */}

          <div
            className="admin_users_filter_row"
            data-aos="fade-up"
            data-aos-delay="250"
          >

            {/* TABS */}

            <div className="admin_users_tabs">

              <button className="admin_users_tab active">
                View all
              </button>

              <button className="admin_users_tab">
                General
              </button>

              <button className="admin_users_tab">
                Admin
              </button>

              <button className="admin_users_tab">
                Student
              </button>

            </div>

            {/* SEARCH */}

            <div className="admin_users_search">

              <FiSearch />

              <input
                type="text"
                placeholder="Search"
              />

            </div>

          </div>

          {/* =========================
             TABLE
          ========================= */}

          <div
            className="admin_users_table"
            data-aos="fade-up"
            data-aos-delay="300"
          >

            {/* HEADER */}

            <div className="admin_users_table_header">

              <input
                type="checkbox"
                className="admin_users_checkbox"
              />

              <div className="names">
                Name
              </div>

              <div className="roles">
                Role
              </div>

              <div className="status">
                Status
              </div>

              <div className="enrolled">
                Enrolled
              </div>

              <div className="actions">
                Actions
              </div>

            </div>

            {/* =========================
               ROWS
            ========================= */}

            {users.map((user, index) => (

              <div
                className="admin_users_table_row"
                key={user.id}

                /* PERFECT SEQUENTIAL */

                data-aos="fade-left"

                data-aos-delay={
                  350 + index * 100
                }

                data-aos-duration="700"

                data-aos-anchor-placement="top-bottom"
              >

                {/* CHECKBOX */}

                <input
                  type="checkbox"
                  className="admin_users_checkbox"
                />

                {/* USER */}

                <div className="admin_users_user">

                  <img
                    src="https://i.pravatar.cc/100"
                    alt=""
                    className="admin_users_avatar"
                  />

                  <div>

                    <div className="admin_users_user_name">
                      {user.name}
                    </div>

                    <div className="admin_users_user_username">
                      {user.username}
                    </div>

                  </div>

                </div>

                {/* ROLE */}

                <div>

                  <span
                    className={`admin_users_role ${user.role.toLowerCase()}`}
                  >
                    {user.role}
                  </span>

                </div>

                {/* STATUS */}

                <div className="admin_users_status">

                  {user.status}

                </div>

                {/* ENROLLED */}

                <div className="admin_users_enrolled">

                  {user.enrolled}

                </div>

                {/* ACTIONS */}

                <div className="admin_users_actions">

                  {/* EDIT */}

                  <button className="admin_users_action_btn">

                    <FiEdit2 />

                    Edit

                  </button>

                  {/* BLOCK */}

                  <button className="admin_users_action_btn">

                    <FiSlash />

                    Block

                  </button>

                  {/* DELETE */}

                  <button className="admin_users_action_btn delete">

                    <FiTrash2 />

                    Delete

                  </button>

                </div>

              </div>
            ))}

          </div>

          {/* =========================
             PAGINATION
          ========================= */}

          <div
            className="admin_users_pagination"
            data-aos="fade-up"
            data-aos-delay="400"
          >

            <button className="admin_users_page active">
              1
            </button>

            <button className="admin_users_page">
              2
            </button>

            <button className="admin_users_page">
              3
            </button>

            <button className="admin_users_page">
              ...
            </button>

            <button className="admin_users_page">
              100
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}